import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useUser } from "../../../../hooks/useUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { setLoading } from "../../../../redux/Loading/actions";
import { useState } from "react";
import { formatDate2 } from "../../../../utils/utils";


export const Filter = ({ showFilter, setShowFilter, action, setData, setShowTable }) => {
  const dispatch = useDispatch();
  const user = useUser();
  const [tags, setTags] = useState({});

  const {
    register,
    handleSubmit,
    reset,
  } = useForm({});

  const handleClean = () => {
    reset({});
  };

  const onSubmit = async (data) => {
    setShowTable(false);
    dispatch(setLoading(true));

    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if (user.rol === "user") {
      data.abogado = user.abogado;
    }

    setTags(data);

    let res = await action(data);
    setData(res);

    dispatch(setLoading(false));
    setShowFilter(false);
    setShowTable(true);
  };

  // persona, fecha, inmueble
  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Row className="mt-3">
            <Col className="col-auto" sm={12} md={4}>
              <Form.Label type="number" className="my-2">Usuario</Form.Label>
              <Form.Control
                name="usuario"
                {...register("usuario")}
              />
            </Col>
            <Col className="col-auto" sm={12} md={4}>
              <Form.Label className="my-2">Inmueble</Form.Label>
              <Form.Control
                name="inmueble"
                {...register("inmueble")}
              />
            </Col>
            <Col className="col-auto" sm={12} md={4}>
              <Form.Label className="my-2">Recurso</Form.Label>
              <Form.Control
                name="fecha"
                type="date"
                {...register("fecha")}
              />
            </Col>
          </Row>

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.usuario && (
              <div className="tags">
                <span color="green" key="usuario">
                  Usuario : {tags.usuario}
                </span>
              </div>
            )}

            {tags?.inmueble && (
              <div className="tags">
                <span color="green" key="inmueble">
                  Inmueble : {tags.inmueble}
                </span>
              </div>
            )}

            {tags?.fecha && (
              <div className="tags">
                <span color="green" key="fecha">
                  Fecha : {formatDate2(tags.fecha)}
                </span>
              </div>
            )}
          </Row>
        }
      </>
    </div>
  );
};
